import { CurrentOpeningsComponent } from './CurrentOpenings';
export default CurrentOpeningsComponent;
